const requiredValidator = (value = 'validators.requiredValidator') => ({
  required: value
});

export default requiredValidator;
